class ConfigurationHelper {
  allowedCharacters = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789']

  isValidConfigurationCode(configurationCode) {
    if (!configurationCode) return false

    if (configurationCode.length < 6 || configurationCode.length > 8) return false

    if (/^\d{6}$/.test(configurationCode)) return false

    configurationCode = configurationCode.toUpperCase()
    ;[...configurationCode].forEach((c) => {
      if (!this.allowedCharacters.includes(c)) return false
    })

    return true
  }

  isValidShoppingCartId(cartId) {
    if (!cartId) return false

    cartId = cartId.toUpperCase()
    ;[...cartId].forEach((c) => {
      if (!this.allowedCharacters.includes(c)) return false
    })

    if (cartId?.length != 6) return false

    if (/^\d{6}$/.test(cartId)) return false

    return true
  }

  isValidKomNumber(komNumber) {
    if (!komNumber) return false

    //TEST.* is for dev/uat playwright tests; All other commission numbers are supposed to be numeric
    return /^(\d+|TEST.*)$/.test(komNumber)
  }

  generateConfigurationRoute(routeParams, routeQuery, configurationCode = null, cartId = null) {
    const params = {}
    if (routeParams) {
      Object.keys(routeParams)
        .filter(
          (key) => key.toLowerCase() !== 'configurationcode' && key.toLowerCase() !== 'cartid'
        )
        .map((key) => {
          params[key] = routeParams[key]
        })
    }
    const query = {}
    if (routeQuery) {
      Object.keys(routeQuery)
        .filter((key) => !['configuratie', 'code', 'encryptedcartid'].includes(key.toLowerCase()))
        .map((key) => {
          query[key] = routeQuery[key]
        })
    }
    if (configurationCode) {
      params['configurationCode'] = configurationCode
    }
    if (cartId) {
      params['cartId'] = cartId
    }
    return {
      params: params,
      query: query,
    }
  }
}

export default new ConfigurationHelper()
